import React, { useState, useEffect } from 'react';
import { getBuffer } from '../services/api';
import { Box, Typography, Paper, CircularProgress, Alert, Divider } from '@mui/material';

const DebugView: React.FC = () => {
    const [buffer, setBuffer] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchBuffer = async () => {
            try {
                setLoading(true);
                const data = await getBuffer();
                setBuffer(data);
            } catch (err) {
                setError('無法載入備用組合。');
            } finally {
                setLoading(false);
            }
        };

        fetchBuffer(); // Initial fetch
        const interval = setInterval(fetchBuffer, 3000); // Poll every 3 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    const renderMatch = (matchInfo: any, index: number) => {
        if (!matchInfo || !matchInfo.match) return null;

        const team1 = matchInfo.teams?.team1 || [];
        const team2 = matchInfo.teams?.team2 || [];
        const players = matchInfo.match || [];

        const team1Names = team1.map((id: number) => players.find((p: any) => p.id === id)?.name || id).join(' & ');
        const team2Names = team2.map((id: number) => players.find((p: any) => p.id === id)?.name || id).join(' & ');

        return (
            <Box key={index} my={1}>
                <Typography variant="body2"><strong>備用組合 #{index + 1}</strong> (綜合評分: {matchInfo.score?.toFixed(2)})</Typography>
                <Typography variant="caption" sx={{ ml: 1 }}>品質: {matchInfo.quality_score?.toFixed(2)} | 隊伍: {team1Names} vs {team2Names}</Typography>
            </Box>
        );
    };

    return (
        <Paper elevation={3} sx={{ p: 2, mt: 4 }}>
            <Typography variant="h6" gutterBottom>除錯模式：備用組合檢視器</Typography>
            <Divider />
            {loading && <CircularProgress size={20} />}
            {error && <Alert severity="error">{error}</Alert>}
            {!loading && !error && (
                <Box mt={1}>
                    {buffer.length > 0 ? buffer.map(renderMatch) : <Typography variant="body2">緩衝區目前為空。</Typography>}
                </Box>
            )}
        </Paper>
    );
};

export default DebugView;
